import {detect} from 'detect-browser';

import {getGemSettingsFeature} from 'app/utils/config/getGemSettingsFeature';
import {GemSettings} from 'app/utils/config/interface';
import {isHuawei, isIOS} from 'app/utils/detect/isBrowser';
import {replacePageInHistory} from 'app/utils/location/replacePageInHistory';
import {OperatingSystemRedirectConfig} from 'interfaces/common/components/configuration/operatingsystemredirect/operatingSystemRedirectConfig';

export const redirectByOperatingSystem = (gemSettings: GemSettings) => {
    if (gemSettings.wcmMode === 'EDIT') {
        return;
    }

    const config = getGemSettingsFeature<OperatingSystemRedirectConfig>(gemSettings, 'operatingSystemRedirect');
    if (!config) {
        return;
    }

    const redirectUrl = getRedirectUrl(config);
    if (redirectUrl) {
        replacePageInHistory(redirectUrl);
    }
};

function getRedirectUrl(config: OperatingSystemRedirectConfig) {
    if (isIOS()) {
        return config.iosUrl;
    }

    if (isHuawei()) {
        return config.huaweiUrl;
    }

    const detected = detect();
    if (detected?.os === 'Android OS') {
        return config.androidUrl;
    }
}
